<template>
  <div>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <type-filter
              v-model="filters.type"
              item-text="name"
              item-value="id"
            />
          </td>
          <td>
            <device-codes-filter
              v-model="filters.device_code"
              item-text="name"
              item-value="name"
            />
          </td>
          <td>
            <serial-numbers-filter v-model="filters.serial_number" />
          </td>
          <td>
            <phone-filter v-model="filters.phone" />
          </td>
          <td>
            <state-filter
              v-model="filters.states"
              item-value="id"
              item-text="name"
              chips
              multiple
              clearable
              small-chips
              deletable-chips
            />
          </td>
          <td>
            <v-checkbox
              v-model="filters.show_all"
              name="show_all"
              :label="$t('WAREHOUSE.SHOW_ALL')"
            />
          </td>
          <td>
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="grey"
                    depressed
                    outlined
                    @click="reset"
                    v-on="on"
                  >
                    <v-icon>mdi-filter-remove</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
              </v-tooltip>
              <v-spacer class="mx-1"></v-spacer>
              <v-btn color="primary" depressed @click.prevent="refreshData">
                {{ $t('BUTTON.FIND') }}
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TypeFilter from './filters/TypeFilter.vue';
import SerialNumbersFilter from './filters/SerialNumbersFilter.vue';
import PhoneFilter from './filters/PhoneFilter.vue';
import StateFilter from './filters/StateFilter.vue';
import DeviceCodesFilter from './filters/DeviceCodesFilter.vue';

export default {
  name: 'WarehouseDevicesListFilter',

  components: {
    DeviceCodesFilter,
    TypeFilter,
    PhoneFilter,
    SerialNumbersFilter,
    StateFilter
  },

  data() {
    return {
      filters: {}
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type.name'
        },
        {
          text: this.$t('DEVICES.DEVICE_CODE'),
          value: 'name'
        },
        {
          text: this.$t('DEVICES.SERIAL_NUMBER'),
          value: 'serial_number'
        },
        {
          text: this.$t('DEVICES.PHONE'),
          value: 'phone'
        },
        {
          text: this.$t('DEVICES.STATE'),
          value: 'status'
        },
        {
          text: '',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ];
    }
  },

  methods: {
    refreshData() {
      this.$emit('setRequest', { ...this.filters });
    },

    reset() {
      this.filters = {};
      this.refreshData();
    }
  }
};
</script>
